<template>
  <div class="group-layout clearfix">
    <group-header class="header-wrap layout-transition-up"
                  @onLoading="onLoading" />
    <div class="view-wrap layout-transition-fade">
      <router-view class="content-wrap"/>
    </div>
    <transition name="loading">
      <div class="loading--wrap layout-transition-fade"
           v-if="onceLoaded && (loadingCount || longLoadingCount)">
        <ba-loading :applyBackground="true"
                    :showLoadingText="true"/>
      </div>
    </transition>
  </div>
</template>

<script>
import store from '@/store'
import { mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'

import GroupHeader from '@/components/group/Header'
import BaLoading from '@/components/ui/ba/Loading'

export default {
  name: 'GroupLayout',
  components: {
    GroupHeader,
    BaLoading
  },
  created () {
    store.dispatch('storeScrollbarWidth')

    EventBus.$on('onLoading', (value) => {
      this.onLoading(value)
    })
    EventBus.$on('onLongLoading', (value) => {
      this.onLongLoading(value)
    })
    EventBus.$on('onError', (error, code = 500) => {
      this.setErrorData({ code, error })
    })
  },
  methods: {
    ...mapMutations([
      'setJourneyOptions',
      'setErrorData'
    ]),

    onLoading (value) {
      if (!value) {
        this.loadingCount--

        setTimeout(() => {
          this.loading = value
        }, 500)

        if (!this.onceLoaded) {
          setTimeout(() => {
            this.onceLoaded = true
          }, 1000)
        }
      } else {
        this.loadingCount++
        this.loading = value
      }
    },

    onLongLoading (value) {
      this.longLoading = value

      if (!value) {
        this.longLoadingCount--
        if (!this.onceLoaded) {
          setTimeout(() => {
            this.onceLoaded = true
          }, 1000)
        }
      } else {
        this.longLoadingCount++
      }
    }
  },
  data () {
    return {
      onceLoaded: false,
      loading: true,
      longLoading: false,
      loadingCount: 0,
      longLoadingCount: 0
    }
  }
}
</script>

<style lang="scss">
.group-layout {
  width: 100%;
  min-width: 1250px;
  min-height: 560px;

  .header-wrap {
    transition: transform 0.3s ease,
    margin-bottom 0.3s ease;
  }

  .view-wrap {
    height: calc(100% - 116px);
    transition: height 0.3s ease;

    .content-wrap {
      position: relative;
      height: 100%;
    }
  }

  .loading--wrap {
    width: 100%;
    height: 100%;
    @include positionXYcenter;
    position: fixed;
    z-index: 9999999;

    .loading {
      @include positionXYcenter;
    }
  }
}

.loading-enter, .loading-leave-to{
  opacity: 0;
}
</style>
